module.exports = __webpack_public_path__ + "img/IMG_8919_v2@2x.199cafac.png";